'use client';

import { useEffect } from 'react';
import { monitoring } from '@/adapters/monitoring';
import { strings } from '@/content/strings';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    monitoring.captureException(error, { scope: 'app-error' });
  }, [error]);

  return (
    <div className="min-h-screen bg-background text-foreground flex items-center justify-center p-6">
      <div className="w-full max-w-md rounded-2xl border border-border bg-card p-6 shadow-sm space-y-3">
        <h1 className="text-xl font-semibold">{strings.screens.error.title}</h1>
        <p className="text-sm text-muted-foreground">{strings.screens.error.subtitle}</p>
        <button
          type="button"
          onClick={reset}
          className="inline-flex items-center justify-center rounded-lg bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground"
        >
          {strings.screens.error.retry}
        </button>
      </div>
    </div>
  );
}
